import { i18n } from '../../domain/i18n.js';
import { BaseComponent } from '../../base.component.js';

export class AbTuvMark extends BaseComponent {

  render({ type }, _, { txt, imgGlobal, composition }) {
    const imageSrc = composition ? composition.parts.tuvSeal.imageSrc : null;

    const src = imgGlobal(imageSrc || 'tuev-badge.svg');
    return (
      <div className={`ab-tuv-mark ab-type-${type}`}>
        <div className="ab-tuv-zone">
          {type === 'seal' && <img className="ab-tuv-mark-image" src={src} alt={txt(i18n.alt.tuvSeal)} onError={() => this.badgeService.notifyImageError(src)} />}
        </div>
      </div>
    );
  }

}
